import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */

/** API */
import TreatmentCourseTypeApi from 'api/setting/treatment-courses/treatment-course-type.api'

/** UTILS || SLICE */
import { resetModal, submitModal, unSubmitModal } from 'app/slice/modal.slice'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableRowExport from 'component/Pdf/TableRowExport'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { dateTimeToView } from 'utils/date.utils'
import { exportCourseTypeToExcel } from './exportCourseTypeToExcel'

const initStateErrorMessage = {
  TREATMENT_COURSE_TYPE_NAME: ``,
  IS_DUPLICATE_TREATMENT_COURSE_TYPE_NAME: ``,
  TREATMENT_COURSE_TYPE_NAME_STRING_BASE: ``,
  TREATMENT_COURSE_TYPE_NAME_STRING_EMPTY: ``,
  TREATMENT_COURSE_TYPE_NAME_MAXIMUM_LENGTH: ``,
  TREATMENT_COURSE_TYPE_NAME_ANY_REQUIRED: ``,

  TREATMENT_COURSE_TYPE_NAME_EN: ``,
  IS_DUPLICATE_TREATMENT_COURSE_TYPE_NAME_EN: ``,
  TREATMENT_COURSE_TYPE_NAME_EN_STRING_BASE: ``,
  TREATMENT_COURSE_TYPE_NAME_EN_STRING_EMPTY: ``,
  TREATMENT_COURSE_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  TREATMENT_COURSE_TYPE_NAME_EN_ANY_REQUIRED: ``
}
export default function TreatmentCourseTypes() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const componentRef = useRef<any>(null)
  const [treatmentCourseTypes, setTreatmentCourseTypes] = useState([])
  const [exportData, setExportData] = useState([])

  const [treatmentCourseTypeId, setTreatmentCourseTypeId] = useState(Number)
  const [treatmentCourseTypeName, setTreatmentCourseTypeName] = useState('')
  const [treatmentCourseTypeNameEn, setTreatmentCourseTypeNameEn] = useState('')
  const [treatmentCourseTypeStatus, setTreatmentCourseTypeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isPopup, setIsPopup] = useState(false)

  const loadData = async () => {
    try {
      let condition = {}
      condition = {
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      }
      const resp = await TreatmentCourseTypeApi.findAll(condition)
      const respExport = await TreatmentCourseTypeApi.findAll({ ...condition, export: 1 })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setTreatmentCourseTypes(resp.data)
        setExportData(respExport.data)
      } else {
        setTreatmentCourseTypes([])
        setExportData([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])


  const submit = () => {
    setDisabledSubmit(true)
    if (!treatmentCourseTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ TREATMENT_COURSE_TYPE_NAME: t('TREATMENT_COURSE_TYPE.MESSAGE.TREATMENT_COURSE_TYPE_NAME') } })
    }

    dispatch(submitModal())
    TreatmentCourseTypeApi.create({ treatmentCourseTypeName, treatmentCourseTypeNameEn })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('TREATMENT_COURSE_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_COURSE_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_COURSE_TYPE.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!treatmentCourseTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ TREATMENT_COURSE_TYPE_NAME: t(`TREATMENT_COURSE_TYPE.MESSAGE.TREATMENT_COURSE_TYPE_NAME`) } })
    }

    dispatch(submitModal())
    TreatmentCourseTypeApi.update(treatmentCourseTypeId, {
      treatmentCourseTypeName,
      treatmentCourseTypeNameEn,
      status: treatmentCourseTypeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`TREATMENT_COURSE_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_COURSE_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_COURSE_TYPE.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setTreatmentCourseTypeId(0)
    setTreatmentCourseTypeName('')
    setTreatmentCourseTypeNameEn('')
    setTreatmentCourseTypeStatus('')
    clearErrorMessage()
    setIsPopup(false)
  }

  const onActive = () => {
    if (id) {
      TreatmentCourseTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_COURSE_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_COURSE_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      TreatmentCourseTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_COURSE_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_COURSE_TYPE.MESSAGE.ERROR'))
        }
      }).catch((error) => {
        setIsOpenAlertModal(false)
        setIsOpenSnack(true)
        setTypeSnack("error")
        if (error.response?.data?.message === 'COURSE_TYPE_IS_USED') {
          setLabelSnack(t(`TREATMENT_COURSE_TYPE.MESSAGE.${error.response?.data?.message}`))
        } else {
          setLabelSnack(t('TREATMENT_COURSE_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { treatmentCourseTypeId: txTypeId, treatmentCourseTypeName: txTypeName, treatmentCourseTypeNameEn: txTypeNameEn, status: txTypeStatus } = data
    setTreatmentCourseTypeId(txTypeId)
    setTreatmentCourseTypeName(txTypeName)
    setTreatmentCourseTypeNameEn(txTypeNameEn)
    setTreatmentCourseTypeStatus(txTypeStatus)
    // dispatch(showModal())
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'treatmentCourseTypeName', disablePadding: false, label: t('TREATMENT_COURSE_TYPE.TABLE.CELL.TREATMENT_COURSE_TYPE_NAME') },
    { id: 'treatmentCourseTypeNameEn', disablePadding: false, label: t('TREATMENT_COURSE_TYPE.TABLE.CELL.TREATMENT_COURSE_TYPE_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('TREATMENT_COURSE_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('TREATMENT_COURSE_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number, valueExportData: boolean) => {
    const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
    const { treatmentCourseTypeId: txTypeId, treatmentCourseTypeName: txTypeName, treatmentCourseTypeNameEn: txTypeNameEn, updatedBy, updatedAt, status: txTypeStatus } = objData
    const statusBtnActive = txTypeStatus === 'ACTIVE' ? true : false
    const statusBtnInActive = txTypeStatus === 'INACTIVE' ? true : false
    const objRenderData = {
      key: txTypeId,
      id: txTypeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: num },
        { option: 'TEXT', align: 'left', label: txTypeName || '-' },
        { option: 'TEXT', align: 'left', label: txTypeNameEn || '-' },
        { option: 'STATUS', align: 'center', label: txTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: false },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: false }
          ]
        }
      ]
    }
    return (
      <>
        {valueExportData === true && <TableRowExport {...objRenderData} /> ||
          <TableRowCommon
            {...objRenderData}
            onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
            oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            onedit={() => onEdit(objRenderData.obj)}
            ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
          />
        }
      </>
    )
  }
  const filter = [
    { label: `${t('INPUT.SEARCH')}: ${search || '-'}` },
    { label: `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}` }
  ]

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.treatmentCourseTypeName)
    setNameEn(obj.treatmentCourseTypeNameEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`TREATMENT_COURSE_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`TREATMENT_COURSE_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { treatmentCourseTypeName: name, treatmentCourseTypeNameEn: nameEn && `(${nameEn})`, status: t(`TREATMENT_COURSE_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={treatmentCourseTypeId ? t('TREATMENT_COURSE_TYPE.TITLE_UPDATE') : t('TREATMENT_COURSE_TYPE.TITLE_CREATE')}
        isOpen={isPopup}
        onCancel={{ onClick: () => resetForm() }}
        onSubmit={{ onClick: () => treatmentCourseTypeId ? submitEdit() : submit(), disabled: disabledSubmit }}
        handleClose={resetForm}
        size={'XS'}
      >
        <Box className="py-2">
          {treatmentCourseTypeId ? (
            <Box component="form" sx={{ mx: 0, mt: 0, mb: '16px', p: 0, display: 'inline-flex', width: '100%' }}>
              <Box component="label" sx={{ mr: 'auto' }}>{t('INPUT.LABEL_STATUS')}</Box>
              <SwitchButton
                onChange={() => setTreatmentCourseTypeStatus(treatmentCourseTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                checked={treatmentCourseTypeStatus === 'ACTIVE' ? true : false}
              />
            </Box>
          ) : (
            ''
          )}

          <Box display="flex" flexDirection="column" gap='24px'>
            <TextInput
              fullWidth
              onChange={(event) => {
                setTreatmentCourseTypeName(event.target.value)
                clearErrorMessage()
              }}
              value={treatmentCourseTypeName}
              label={t('TREATMENT_COURSE_TYPE.INPUT.TREATMENT_COURSE_TYPE_NAME')}
              helperText={
                errorMessage.TREATMENT_COURSE_TYPE_NAME ||
                errorMessage.IS_DUPLICATE_TREATMENT_COURSE_TYPE_NAME ||
                errorMessage.TREATMENT_COURSE_TYPE_NAME_STRING_BASE ||
                errorMessage.TREATMENT_COURSE_TYPE_NAME_STRING_EMPTY ||
                errorMessage.TREATMENT_COURSE_TYPE_NAME_MAXIMUM_LENGTH ||
                errorMessage.TREATMENT_COURSE_TYPE_NAME_ANY_REQUIRED
              }
              required={true}
            />
            <TextInput
              fullWidth
              onChange={(event) => {
                setTreatmentCourseTypeNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={treatmentCourseTypeNameEn}
              helperText={
                errorMessage.TREATMENT_COURSE_TYPE_NAME_EN ||
                errorMessage.IS_DUPLICATE_TREATMENT_COURSE_TYPE_NAME_EN ||
                errorMessage.TREATMENT_COURSE_TYPE_NAME_EN_STRING_BASE ||
                errorMessage.TREATMENT_COURSE_TYPE_NAME_EN_STRING_EMPTY ||
                errorMessage.TREATMENT_COURSE_TYPE_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.TREATMENT_COURSE_TYPE_NAME_EN_ANY_REQUIRED
              }
              label={t('TREATMENT_COURSE_TYPE.INPUT.TREATMENT_COURSE_TYPE_NAME_EN')}
              required={false}
            />
          </Box>

        </Box>
      </PageModal>
      <HeaderCard text={t('TREATMENT_COURSE_TYPE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('TREATMENT_COURSE_TYPE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                  if (e === 'Excel') {
                    const report: any = {
                      title: t('TREATMENT_COURSE_TYPE.TITLE'),
                      statusFilter: filter[1].label,
                      rows: exportData.map((item: any) => ({
                        treatmentCourseTypeName: item?.treatmentCourseTypeName || '-',
                        treatmentCourseTypeNameEn: item?.treatmentCourseTypeNameEn || '-',
                        status: t(`STATUS.${item?.status}`),
                        updatedBy: item?.updatedBy,
                        updatedAt: dateTimeToView(item?.updatedAt) || '-'
                      })),
                      t
                    }
                    exportCourseTypeToExcel(report)
                  } else if (e === 'PDF') {
                    const style = document.createElement("style");
                    style.innerHTML = `
                      @media print {
                        @page { size: portrait }
                      }
                    `;
                    document.head.appendChild(style);
                    window.print();
                    document.head.removeChild(style);

                  }
                }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
                <MainButton title={t('TREATMENT_COURSE_TYPE.BUTTON.ADD')} type='primary' variant='contained' onClick={() => setIsPopup(true)} startIcon={<AddCircleIcon />} />
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={treatmentCourseTypes.map((val, i) => {
              return renderData(val, i, false)
            })}
          />

          <Box
            id="print-table-container"
            ref={componentRef}
          >
            <Typography fontSize="14px" fontWeight={400}>{t('TREATMENT_COURSE_TYPE.TITLE')}</Typography>
            <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
              <Typography fontSize="10px" fontWeight={400}>{t('STATUS.LABEL')}: {status === 'ALL' ? t('STATUS.ALL') : status === 'ACTIVE' ? t('STATUS.ACTIVE') : t('STATUS.INACTIVE')}</Typography>
            </Box>
            <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
              <thead>
                <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                  <th style={{ borderBottom: '1px solid black' }}>{t('#')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('TREATMENT_COURSE_TYPE.TABLE.CELL.TREATMENT_COURSE_TYPE_NAME')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('TREATMENT_COURSE_TYPE.TABLE.CELL.TREATMENT_COURSE_TYPE_NAME_EN')}</th>
                  <th style={{ borderBottom: '1px solid black' }}>{t('TREATMENT_COURSE_TYPE.TABLE.CELL.STATUS')}</th>
                  <th style={{ borderBottom: '1px solid black' }}>{t('TREATMENT_COURSE_TYPE.TABLE.CELL.UPDATED_BY')}</th>
                </tr>
              </thead>
              <tbody>
                {exportData?.length === 0 &&
                  <tr>
                    <td colSpan={5} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
                  </tr>
                }
                {exportData.map((data: any, index: number) => (
                  <tr key={index}>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{index + 1}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.treatmentCourseTypeName || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.treatmentCourseTypeNameEn || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100px' }}>{t(`STATUS.${data?.status}`) || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <span>{data?.updatedBy || '-'}</span>
                      <span>{dateTimeToView(data?.updatedAt) || '-'}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
